import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
import { createCustomerValidationForm } from "../../utils/validationSchema";
import Button from "../Reusable/Button";
import CustomerForm from "../Customer/CustomerForm";

const CreateCustomer = (props: any) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    clearErrors
  } = useForm<any>({
    resolver: yupResolver(createCustomerValidationForm),
  });
  const { handleCreate, isLoading } = props;

  return (
    <form onSubmit={handleSubmit((data: any) => handleCreate(data, setError))} autoComplete="off">
      <CustomerForm
        clearErrors={clearErrors}
        errors={errors}
        register={register}
        setValue={setValue}
      />
      <div className="flex justify-end w-full">
        <div className="w-[100px] mr-4">
          <Button label={"Create"} isLoading={isLoading} />
        </div>
      </div>
    </form>

  );
};

export default CreateCustomer;
